/** @format */

import {makeStyles, createStyles} from '@mui/styles';
import {css, styled, Theme} from '@mui/material/styles';

import {Box, Typography} from '@mui/material';

import {getColor} from '../helpers/getColor';
import {VariantType} from '../model/types';

interface Props {
  colorScheme: VariantType;
}

export const StyledRow = styled(Box, {
  shouldForwardProp: prop => prop !== 'colorScheme',
})<Props>(
  ({theme, colorScheme}) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: ${theme.spacing(2)};
    padding: ${theme.spacing(4)};
    border-radius: ${theme.spacing(2)};
    background: ${theme.palette.semantic_dark?.surface.surface1};
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.05);
    border-right: 2px solid ${theme.palette.figma_gray_middle_dark?.main};
    border-left: 2px solid ${theme.palette.figma_gray_middle_dark?.main};
    border-color: ${getColor(colorScheme, theme.palette.figma_gray_middle_dark?.main || '')};
    margin-bottom: ${theme.spacing(1)};
    '&:first-of-type': {
      margin-top: 0;
    }
    '& .muibuttonbase-root': {
      padding: 0;
      align-items: center;
      justify-content: space-between;
      border-radius: 0;
      background-color: transparent;

      ${theme.breakpoints.down('sm')} {
        flex-wrap: wrap;
      }
    }
  `,
);

export const StyledRecommendations = styled(Box, {
  shouldForwardProp: prop => prop !== 'colorScheme',
})<Props>(
  ({theme, colorScheme}) => css`
    width: 160px;
    display: flex;
    flex-wrap: wrap;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    padding: ${theme.spacing(1.5, 4)};
    border-radius: ${theme.spacing(2)};
    border-width: 1px;
    border-style: solid;
    border-color: ${getColor(colorScheme, theme.palette.figma_gray_middle_dark?.main || '')};
    ${theme.breakpoints.down('sm')} {
      width: 100%;
      max-width: 100%;
    },
  `,
);

export const StyledRecommendationsText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'colorScheme',
})<Props>(({colorScheme, theme}) => ({
  color: getColor(colorScheme, theme.palette.figma_gray_middle_dark?.main || ''),
  fontSize: 14,
  fontWeight: 400,
}));

export const useSensorBarBunchStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      color: theme.palette.text.primary,
      fontSize: 20,
      fontWeight: 700,
      lineHeight: '26px',
      letterSpacing: '0.17px',
    },
    description: {
      color: theme.palette.figma_gray_middle_dark?.main,
      fontSize: '14px',
      fontWeight: 400,
    },
    rightContainer: {
      minWidth: theme.spacing(26),
    },
    rowIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 66,
      height: 66,
      flexShrink: 0,
      marginRight: theme.spacing(4),
      borderRadius: theme.spacing(2),
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      maxWidth: '82%',
      [theme.breakpoints.down('sm')]: {
        maxWidth: '100%',
      },
    },
    titleBox: {
      display: 'flex',
      gap: theme.spacing(1),
    },
    recommendationsWrapper: {
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'center',
      flexDirection: 'column',
      justifyContent: 'space-between',
      flexShrink: 0,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginTop: theme.spacing(4),
      },
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
        maxWidth: '100%',
      },
    },
    compactIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 16,
      height: 16,
    },
    buttonPlate: {
      width: '100%',
    },
    buttonPlateContainer: {
      justifyContent: 'space-between',
      padding: '0 !important',
    },
  }),
);
